/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S9_HeadingInputs */

const tr_kullanim_s9_heading = /** @type {(inputs: Kullanim_S9_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Sorumluluğun Sınırlandırılması`)
};

const en_kullanim_s9_heading = /** @type {(inputs: Kullanim_S9_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Limitation of liability`)
};

const de_kullanim_s9_heading = /** @type {(inputs: Kullanim_S9_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Haftungsbeschränkung`)
};

const ru_kullanim_s9_heading = /** @type {(inputs: Kullanim_S9_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Ограничение ответственности`)
};

/**
* | output |
* | --- |
* | "9. Limitation of liability" |
*
* @param {Kullanim_S9_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s9_heading = /** @type {((inputs?: Kullanim_S9_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S9_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s9_heading(inputs)
	if (locale === "de") return de_kullanim_s9_heading(inputs)
	if (locale === "ru") return ru_kullanim_s9_heading(inputs)
	return tr_kullanim_s9_heading(inputs)
});